import { Box, CircularProgress, Typography } from '@material-ui/core'
import useProductLoad from 'pages/ProductLoad/useProductLoad'
import colors from 'theme/colors'

const ProductLoad = (): JSX.Element => {
    useProductLoad()

    return (
        <Box
            sx={{
                bgcolor: colors.white,
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
                height: {
                    xs: 'calc(100vh - 304px)',
                    sm: 'calc(100vh - 231px)',
                    md: 'calc(100vh - 190px)',
                },
            }}
        >
            <CircularProgress style={{ color: colors.green }} size={'140px'} />
            <Typography style={{ marginTop: '40px' }}>LOADING</Typography>
        </Box>
    )
}

export default ProductLoad
